import React from 'react';

export interface ScoreBadgeProps {
  score: number;
  size?: 'xs' | 'sm' | 'md' | 'lg';
  showLabel?: boolean;
}

export const ScoreBadge: React.FC<ScoreBadgeProps> = ({
  score,
  size = 'md',
  showLabel = false,
}) => {
  const getScoreColor = (score: number): string => {
    if (score >= 9.5) return 'text-emerald-400 bg-emerald-500/20 border-emerald-400/30';
    if (score >= 9.0) return 'text-green-400 bg-green-500/20 border-green-400/30';
    if (score >= 8.5) return 'text-cyan-400 bg-cyan-500/20 border-cyan-400/30';
    if (score >= 8.0) return 'text-blue-400 bg-blue-500/20 border-blue-400/30';
    if (score >= 7.0) return 'text-yellow-400 bg-yellow-500/20 border-yellow-400/30';
    return 'text-red-400 bg-red-500/20 border-red-400/30';
  };

  const getScoreLabel = (score: number): string => {
    if (score >= 9.5) return 'Exceptional';
    if (score >= 9.0) return 'Excellent';
    if (score >= 8.5) return 'Very Good';
    if (score >= 8.0) return 'Good';
    if (score >= 7.0) return 'Fair';
    return 'Poor';
  };

  const getSizeClasses = (size: 'xs' | 'sm' | 'md' | 'lg'): string => {
    switch (size) {
      case 'xs':
        return 'px-1 py-0.5 text-[9px] leading-3 min-w-[1.75rem]';
      case 'sm':
        return 'px-2 py-0.5 text-xs';
      case 'md':
        return 'px-2.5 py-1 text-sm';
      case 'lg':
        return 'px-3 py-1.5 text-base';
      default:
        return 'px-2.5 py-1 text-sm';
    }
  };

  const colorClasses = getScoreColor(score);
  const sizeClasses = getSizeClasses(size);
  const label = getScoreLabel(score);

  return (
    <div className="flex items-center space-x-1">
      <span
        className={`
          inline-flex items-center justify-center font-medium rounded-full border backdrop-blur-sm
          ${colorClasses} ${sizeClasses}
        `}
        title={showLabel ? undefined : label}
      >
        {score.toFixed(2)}
      </span>
      {showLabel && (
        <span className="text-slate-400 text-xs">
          {label}
        </span>
      )}
    </div>
  );
};